export default __webpack_public_path__ + "static/media/es.19131663.svg";